import script from "./blockList.vue?vue&type=script&setup=true&lang=js"
export * from "./blockList.vue?vue&type=script&setup=true&lang=js"

import "./blockList.vue?vue&type=style&index=0&id=5474d07a&lang=css"

const __exports__ = script;

export default __exports__